import React, { PropTypes } from "react";
//import LeaveModal from "../wallChart/Modal";
import classnames from "classnames";

import { getMods } from "./util";

const clsPrefix = "rc-Day";

const renderHeader = props => {
  if (!props.dayHeader) {
    return null;
  }

  return (
    <header className={`${clsPrefix}-Day-header`}>
      {props.date.format(props.dayHeaderFormat)}
    </header>
  );
};

const renderAgenda = props => {
  if (!props.dayAgenda) {
    return null;
  }

  return (
    <div key="agenda" className={`${clsPrefix}-Day-agenda`}>
      {props.children}
    </div>
  );
};

const Day = props => {
  const clsPrefix = "rc-Day";
  const { date, mods, outside } = props;
  const modifiers = getMods(mods, date, clsPrefix, "day");

  let clsMods, events, styles, groupId, secondaryId, firstHalfGroupId, secondHalfGroupId, isGroup, groupFirstHalf, groupSecondHalf, leaveType, specialGroupId;

  if (modifiers) {
    clsMods = modifiers.clsMods;
    events = modifiers.events;
    styles = modifiers.styles;
    isGroup = modifiers.isGroup;
    groupId = modifiers.id; // Get group ID from modifiers (for full day leaves)
    secondaryId = modifiers.secondaryId; // Get secondary ID for combined entries
    firstHalfGroupId = modifiers.firstHalfGroupId; // Get first half group ID for single half-day leaves
    secondHalfGroupId = modifiers.secondHalfGroupId; // Get second half group ID for single half-day leaves
    groupFirstHalf = modifiers.groupFirstHalf; // Get first half group ID for single half-day leaves
    groupSecondHalf = modifiers.groupSecondHalf; // Get second half group ID for single half-day leaves
    leaveType = modifiers.leaveType; // Get leave type for single half-day leaves
    specialGroupId = modifiers.specialGroupId; // Get special group ID for special group leaves
  }

  // Always use base classes, but when we have dynamic styles, 
  // we'll let the inline styles override the CSS classes
  const clsDay = classnames(clsPrefix, { "rc-Day--outside": outside }, clsMods);

  // Enhanced hover functionality for duplicate IDs
  const enhancedEvents = {
    ...events,

    onMouseMove: (e) => {
      // Check if this is a non-editable leave and skip hover effects
      if (clsMods && clsMods.includes('leave-not-editable')) {
        // Explicitly set cursor to not-allowed and prevent any hover effects
        if (e && e.currentTarget && e.currentTarget.style) {
          e.currentTarget.style.cursor = 'default';
        }
        return; // Skip all hover effects for non-editable leaves
      }

      // Call original onMouseMove if it exists
      if (events && events.onMouseMove) {
        events.onMouseMove(date, e);
      }

      // Only process if this is a combined day or has half-day leaves - Right Half Day and Left Half Day and Special case
      if ((groupId && secondaryId && !isGroup) || (firstHalfGroupId && !isGroup) || (secondHalfGroupId && !isGroup) || (groupId && !isGroup && modifiers && modifiers.firstHalfEntry && modifiers.secondHalfEntry)) {
        const dayElement = e.currentTarget;
        const rect = dayElement.getBoundingClientRect();
        const mouseX = e.clientX - rect.left;
        const dayWidth = rect.width;
        const isLeftHalf = mouseX < (dayWidth / 2);

        // For combined days (both groupId and secondaryId exist) - different groups
        if (groupId && secondaryId && !isGroup) {
          const allElementsWithSameGroup = document.querySelectorAll(`.rc-Day[data-group-id="${groupId}"]`);

          // Remove all existing hover classes first
          allElementsWithSameGroup.forEach(element => {
            element.classList.remove('special-case-id-hover-left');
            element.classList.remove('special-case-id-hover-right');
          });

          // Add appropriate hover class based on current position
          if (isLeftHalf) {
            dayElement.style.cursor = 'pointer';
            dayElement.title = 'Click to edit';

            // Remove special-case-id-hover-left from pickNextGroups when moving to left half
            const pickNextGroups = document.querySelectorAll(`.rc-Day[data-group-id="${secondaryId}"]`);
            pickNextGroups.forEach(element => {
              element.classList.remove('special-case-id-hover-left');
              element.classList.remove('group-hover');
            });
            const nextGroup = document.querySelectorAll(`.rc-Day[data-secondary-group-id="${groupId}"]`);
            if (nextGroup.length > 0) {
              nextGroup.forEach(element => {
                element.classList.add('hover-single-right');
              });
            }
            allElementsWithSameGroup.forEach(element => {
              const leaveType = element.getAttribute('leavetype');
              if (leaveType === "full-day") {
                element.classList.add('group-hover');
              }
              else if (leaveType === "second-half") {
                element.classList.add('hover-single-right');
              }
              else {
                element.classList.add('special-case-id-hover-left');
              }
            });

          } else {
            // Clean up any existing hover classes before jumping into right half case
            const allElementsWithSameGroup = document.querySelectorAll(`.rc-Day[data-group-id="${groupId}"]`);
            allElementsWithSameGroup.forEach(element => {
              element.classList.remove('hover-single-right');
              element.classList.remove('hover-single-left');
              element.classList.remove('group-hover');
              element.classList.remove('special-case-id-hover-left');
            });

            const specialCaseWithGroup = document.querySelectorAll(`.rc-Day[data-special-group-id="${secondaryId}"]`);
            specialCaseWithGroup.forEach(element => {
              element.classList.remove('hover-single-right');
              element.classList.remove('hover-single-left');
              element.classList.remove('special-case-id-hover-right');
              element.classList.remove('special-case-id-hover-left');
            });
            const nextGroup = document.querySelectorAll(`.rc-Day[data-secondary-group-id="${groupId}"]`);
            if (nextGroup.length > 0) {
              nextGroup.forEach(element => {
                element.classList.remove('hover-single-right');
              });
            }

            if (specialCaseWithGroup.length > 0) {
              const pickNextGroups = document.querySelectorAll(`.rc-Day[data-group-id="${secondaryId}"]`);
              dayElement.style.cursor = 'pointer';
              specialCaseWithGroup.forEach(element => {
                element.classList.add('special-case-id-hover-right');
              });
              pickNextGroups.forEach(element => {
                const leaveType = element.getAttribute('leavetype');
                if (leaveType === "full-day") {
                  element.classList.add('group-hover');
                } else {
                  element.classList.add('special-case-id-hover-left');
                }

              });
              allElementsWithSameGroup.forEach(element => {
                element.classList.remove('group-hover');
              });
            } else {
              const secondaryGroup = document.querySelectorAll(`.rc-Day[data-secondary-group-id="${secondaryId}"]`);
              dayElement.style.cursor = 'pointer';
              dayElement.title = 'Click to edit';

              secondaryGroup.forEach(element => {
                element.classList.add('special-case-id-hover-right');
              });
              allElementsWithSameGroup.forEach(element => {
                element.classList.remove('group-hover');
              });
            }

          }
        }
        // For special case: same group with both halves (0,0) and (1,1) on same day
        else if (groupId && isGroup && modifiers && modifiers.firstHalfEntry && modifiers.secondHalfEntry) {
          const allElementsWithSameGroup = document.querySelectorAll(`.rc-Day[data-group-id="${groupId}"]`);
          // Remove all existing hover classes first
          allElementsWithSameGroup.forEach(element => {
            element.classList.remove('special-case-same-group-hover');
          });

          // Add hover class for same group special case
          dayElement.style.cursor = 'pointer';
          dayElement.title = 'Click to edit';
          allElementsWithSameGroup.forEach(element => {
            element.classList.add('special-case-same-group-hover');
          });

        }
        // For single half-day leaves
        else if (firstHalfGroupId || secondHalfGroupId) {
          if (isLeftHalf && firstHalfGroupId) {
            const allElementsWithSameGroup = document.querySelectorAll(`.rc-Day[data-first-half-group-id="${firstHalfGroupId}"]`);
            // Mouse is in left half with existing leave
            dayElement.style.cursor = 'pointer';
            dayElement.title = 'Click to edit';
            allElementsWithSameGroup.forEach(element => {
              element.classList.add('hover-single-left');
            });
          } else if (!isLeftHalf && secondHalfGroupId) {
            const allElementsWithSameGroup = document.querySelectorAll(`.rc-Day[data-second-half-group-id="${secondHalfGroupId}"]`);
            // Mouse is in right half with existing leave
            dayElement.style.cursor = 'pointer';
            dayElement.title = 'Click to edit';
            allElementsWithSameGroup.forEach(element => {
              element.classList.add('hover-single-right');
            });
          } else {
            const allElementsWithSameGroup1 = document.querySelectorAll(`.rc-Day[data-first-half-group-id="${firstHalfGroupId}"]`);
            const allElementsWithSameGroup2 = document.querySelectorAll(`.rc-Day[data-second-half-group-id="${secondHalfGroupId}"]`);
            allElementsWithSameGroup1.forEach(element => {
              element.classList.remove('hover-single-left');
            });
            allElementsWithSameGroup2.forEach(element => {
              element.classList.remove('hover-single-right');
            });
            // Mouse is in unoccupied half
            dayElement.style.cursor = 'pointer';
            dayElement.title = `Click to add new leave`;
          }
        }
      }
      else if (groupId && !isGroup) { // Single Full Day
        const allElementsWithSameGroup = document.querySelectorAll(`.rc-Day[data-group-id="${groupId}"]`);
        allElementsWithSameGroup.forEach(element => {
          element.classList.remove('hover-left');
          element.classList.remove('hover-right');
        });

        allElementsWithSameGroup.forEach(element => {
          element.classList.add('hover-full-day');
        });

        // Only execute if groupId contains PUBLIC_HOLIDAY
        if (groupId && (groupId.toString().includes('PUBLIC_HOLIDAY') || groupId.toString().includes('public_holiday'))) {
          const dayElement = e.currentTarget;
          dayElement.style.cursor = 'pointer';
          dayElement.title = 'Public Holiday';
        }

      } else if (isGroup) { // Multi-day group
        const allElementsWithSameGroup = document.querySelectorAll(`.rc-Day[data-group-id="${groupId}"]`);
        const dayElement = e.currentTarget;

        // Handle group members (dates 4, 5) - they should always show left half highlight
        if (!groupFirstHalf && !groupSecondHalf) {
          // This is a group member (dates 4, 5) - show left half highlight

          // Clean up any existing hover classes first
          allElementsWithSameGroup.forEach(element => {
            element.classList.remove('hover-single-left');
            element.classList.remove('hover-single-right');
          });

          allElementsWithSameGroup.forEach(element => {
            element.classList.add('group-hover');
          });
          dayElement.style.cursor = 'pointer';
          dayElement.title = 'Click to edit';
        }

        else if (groupFirstHalf && groupSecondHalf) {//This logic basically works if the group has any day which has both halves and inside that we have multiple scenarios.
          const dayElement = e.currentTarget;
          const rect = dayElement.getBoundingClientRect();
          const mouseX = e.clientX - rect.left;
          const dayWidth = rect.width;
          const isLeftHalf = mouseX < (dayWidth / 2);

          // IMPORTANT: Clean up ALL previous hover classes first to prevent accumulation   
          allElementsWithSameGroup.forEach(element => {
            element.classList.remove('group-hover');
            element.classList.remove('hover-single-left');
            element.classList.remove('hover-single-right');
          });

          const pickingGroups = document.querySelectorAll(`.rc-Day[data-special-group-id="${groupId}"]`);
          pickingGroups.forEach(element => {
            element.classList.remove('hover-single-left');
            element.classList.remove('hover-single-right');
          });

          allElementsWithSameGroup.forEach(element => {
            element.classList.remove('hover-single-left');
            element.classList.remove('hover-single-right');
            element.classList.remove('group-hover');
          });

          const secondaryGroup = document.querySelectorAll(`.rc-Day[data-secondary-group-id="${groupId}"]`);
          if (secondaryGroup.length > 0) {
            secondaryGroup.forEach(element => {
              element.classList.remove('hover-single-left');
              element.classList.remove('hover-single-right');
              element.classList.remove('group-hover');
            });
          }

          if (!isLeftHalf) {

            const secondaryGroup = document.querySelectorAll(`.rc-Day[data-secondary-group-id="${secondaryId}"]`);
            const nextGroup = document.querySelectorAll(`.rc-Day[data-group-id="${secondaryId}"]`);
            dayElement.style.cursor = 'pointer';
            dayElement.title = 'Click to edit';

            if (nextGroup.length > 0) {
              nextGroup.forEach(element => {
                const leaveType = element.getAttribute('leavetype');
                if (leaveType === "full-day") {
                  element.classList.add('group-hover');
                }
                else if (leaveType === "first-half") {
                  element.classList.add('hover-single-left');
                }
                else if (leaveType === "second-half") {
                  element.classList.add('hover-single-right');
                } else {
                  element.classList.add('hover-single-left');
                }
              });
            }
            if (secondaryGroup.length > 0) {
              secondaryGroup.forEach(element => {
                element.classList.add('hover-single-right');
              });
            } else {

              if (secondaryGroup) {
                const pickingPrimaryGroups = document.querySelectorAll(`.rc-Day[data-secondary-group-id="${groupId}"]`);
                if (pickingPrimaryGroups.length > 0) {
                  pickingPrimaryGroups.forEach(element => {
                    element.classList.add('hover-single-right');
                  });
                }
              }

              allElementsWithSameGroup.forEach(element => {
                const secondaryGroupId = element.getAttribute('data-secondary-group-id');
                const secondaryGroup = document.querySelectorAll(`.rc-Day[data-secondary-group-id="${groupId}"]`);
                const pickingGroups = document.querySelectorAll(`.rc-Day[data-special-group-id="${groupId}"]`);
                const leaveType = element.getAttribute('leavetype');
                if (pickingGroups.length > 0) {
                  pickingGroups.forEach(element => {
                    element.classList.add('hover-single-right');
                  });
                  if (leaveType === "full-day") {
                    element.classList.add('group-hover');
                  }
                  if (leaveType === "first-half") {
                    element.classList.add('hover-single-left');
                  }
                }
                else {
                  if (secondaryGroupId || leaveType === "first-half") {
                    element.classList.add('hover-single-left');
                  }
                  else if (secondaryGroupId || leaveType === "second-half") {
                    element.classList.add('hover-single-right');
                  }
                  else {
                    element.classList.add('group-hover');
                  }
                }

              });
            }
          } else { //By Default it will run

            const dayElement = e.currentTarget;
            dayElement.style.cursor = 'pointer';
            dayElement.title = 'Click to edit';
            const rect = dayElement.getBoundingClientRect();
            const mouseX = e.clientX - rect.left;
            const dayWidth = rect.width;
            const isLeftHalf = mouseX < (dayWidth / 2);
            if (!isLeftHalf) {
              const secondaryGroup = document.querySelectorAll(`.rc-Day[data-secondary-group-id="${secondaryId}"]`);
              dayElement.style.cursor = 'pointer';
              dayElement.title = 'Click to edit';
              if (secondaryGroup.length > 0) {
                secondaryGroup.forEach(element => {
                  element.classList.add('hover-single-right');
                });
              }

            } else {
              const nextGroup = document.querySelectorAll(`.rc-Day[data-group-id="${secondaryId}"]`);
              if (nextGroup.length > 0) {
                nextGroup.forEach(element => {
                  element.classList.remove('hover-single-left');
                  element.classList.remove('group-hover');
                });
              }

              allElementsWithSameGroup.forEach(element => {
                const secondaryGroupId = element.getAttribute('data-secondary-group-id');
                const pickingPrimaryGroups = document.querySelectorAll(`.rc-Day[data-group-id="${secondaryGroupId}"]`);
                if (pickingPrimaryGroups.length > 0) {
                  pickingPrimaryGroups.forEach(element => {
                    element.classList.remove('hover-single-left');
                  });
                }
              });

              allElementsWithSameGroup.forEach(element => {
                const leaveType = element.getAttribute('leavetype');
                const secondaryGroupId = element.getAttribute('data-secondary-group-id');
                const pickingGroups = document.querySelectorAll(`.rc-Day[data-special-group-id="${groupId}"]`);
                const secondaryGroup = document.querySelectorAll(`.rc-Day[data-secondary-group-id="${groupId}"]`);
                if (secondaryGroup.length > 0) {
                  secondaryGroup.forEach(element => {
                    element.classList.add('hover-single-right');
                  });
                }
                if (pickingGroups.length > 0) {
                  pickingGroups.forEach(element => {
                    element.classList.add('hover-single-right');
                  });
                  if (leaveType === "full-day") {
                    element.classList.add('group-hover');
                  }
                  if (leaveType === "first-half") {
                    element.classList.add('hover-single-left');
                  }
                } else if (secondaryGroupId) {
                  const pickingPrimaryGroups = document.querySelectorAll(`.rc-Day[data-secondary-group-id="${secondaryGroupId}"]`);
                  if (pickingPrimaryGroups.length > 0) {
                    pickingPrimaryGroups.forEach(element => {
                      element.classList.add('hover-single-left');
                    });
                  }

                }
                else {
                  if (leaveType === "full-day") {
                    element.classList.add('group-hover');
                  }
                  else if (leaveType === "first-half") {
                    element.classList.add('hover-single-left');
                  }
                  else if (leaveType === "second-half") {
                    element.classList.add('hover-single-right');
                  }
                }

              });
            }

          }
        }
        // Handle single half-day group leaves
        else if (groupFirstHalf && groupSecondHalf === null) {
          const dayElement = e.currentTarget;
          const rect = dayElement.getBoundingClientRect();
          const mouseX = e.clientX - rect.left;
          const dayWidth = rect.width;
          const isLeftHalf = mouseX < (dayWidth / 2);
          if (isLeftHalf) {
            allElementsWithSameGroup.forEach(element => {
              const leaveType = element.getAttribute('leavetype');
              const pickingGroups = document.querySelectorAll(`.rc-Day[data-special-group-id="${groupId}"]`);
              if (pickingGroups.length > 0) {
                pickingGroups.forEach(element => {
                  element.classList.add('hover-single-right');
                });
                if (leaveType === "full-day") {
                  element.classList.add('group-hover');
                }
                if (leaveType === "first-half") {
                  element.classList.add('hover-single-left');
                }
              } else {
                const secondaryGroupId = element.getAttribute('data-secondary-group-id');
                const nextGroup = document.querySelectorAll(`.rc-Day[data-secondary-group-id="${groupId}"]`);
                if (nextGroup.length > 0) {
                  nextGroup.forEach(element => {
                    const leaveType = element.getAttribute('leavetype');
                    if (leaveType === "full-day") {
                      element.classList.add('group-hover');
                    }
                    else if (leaveType === "first-half") {
                      element.classList.add('hover-single-left');
                    }
                    else {
                      element.classList.add('hover-single-right');
                    }
                  });
                }
                if (secondaryGroupId || leaveType === "first-half") {
                  element.classList.add('hover-single-left');
                }
                else if (secondaryGroupId || leaveType === "second-half") {
                  element.classList.add('hover-single-right');
                }
                else {
                  element.classList.add('group-hover');
                }
              }
            });
          } else {
            // Clean up hover classes from left half when moving to right half
            const pickingGroups = document.querySelectorAll(`.rc-Day[data-special-group-id="${groupId}"]`);
            pickingGroups.forEach(element => {
              element.classList.remove('hover-single-left');
              element.classList.remove('hover-single-right');
            });

            allElementsWithSameGroup.forEach(element => {
              element.classList.remove('hover-single-left');
              element.classList.remove('hover-single-right');
              element.classList.remove('group-hover');
            });

            const secondaryGroup = document.querySelectorAll(`.rc-Day[data-secondary-group-id="${groupId}"]`);
            if (secondaryGroup.length > 0) {
              secondaryGroup.forEach(element => {
                element.classList.remove('hover-single-left');
                element.classList.remove('hover-single-right');
                element.classList.remove('group-hover');
              });
            }

            if (pickingGroups.length === 0 && secondaryGroup.length === 0) {
              dayElement.title = `Click to add new leave`;
            }
          }

        }
        // Handle second half only group leaves
        else if (!groupFirstHalf && groupSecondHalf) {
          //  allElementsWithSameGroup.forEach(element => {
          //     element.classList.add('group-hover-second-half');
          //  });

          const dayElement = e.currentTarget;
          const rect = dayElement.getBoundingClientRect();
          const mouseX = e.clientX - rect.left;
          const dayWidth = rect.width;
          const isLeftHalf = mouseX < (dayWidth / 2);
          if (!isLeftHalf) {
            allElementsWithSameGroup.forEach(element => {
              const leaveType = element.getAttribute('leavetype');
              if (leaveType == 'full-day') {
                element.classList.add('group-hover');
              }
              else if (leaveType == 'first-half') {
                element.classList.add('hover-single-left');
              } else if (leaveType == 'second-half') {
                element.classList.add('hover-single-right');
              }
              //const specialCase = document.querySelectorAll(`.rc-Day[data-group-id="${groupId}"]`);
              const secondaryGroupId = element.getAttribute('data-secondary-group-id');
              const pickingGroups = document.querySelectorAll(`.rc-Day[data-special-group-id="${secondaryGroupId}"]`);
              if (pickingGroups.length > 0) {
                if (leaveType == 'full-day') {
                  element.classList.add('group-hover');
                }
                else if (leaveType == 'first-half') {
                  element.classList.add('hover-single-right');
                }
                else {
                  element.classList.add('hover-single-left');
                }
              }
              if (secondaryGroupId) {
                const pickingPrimaryGroups = document.querySelectorAll(`.rc-Day[data-secondary-group-id="${secondaryGroupId}"]`);
                if (pickingPrimaryGroups.length > 0) {
                  pickingPrimaryGroups.forEach(element => {
                    element.classList.add('hover-single-left');
                  });
                }

              }


            });
          } else {
            allElementsWithSameGroup.forEach(element => {
              element.classList.remove('hover-single-right');
              element.classList.remove('hover-single-left');
              element.classList.remove('group-hover');
            });
          }
        }
      }
    },
    onMouseLeave: (e) => {
      // Check if this is a non-editable leave and skip hover effects
      if (clsMods && clsMods.includes('leave-not-editable')) {
        // Ensure cursor remains not-allowed
        if (e && e.currentTarget && e.currentTarget.style) {
          e.currentTarget.style.cursor = 'default';
        }
        return; // Skip all hover effects for non-editable leaves
      }

      // Call original onMouseLeave if it exists
      if (events && events.onMouseLeave) {
        events.onMouseLeave(date, e);
      }

      // If this element has a group ID, remove highlight from all elements with the same group ID
      if (groupId) {
        // Only find calendar day elements that have the same group ID
        const allElementsWithSameGroup = document.querySelectorAll(`.rc-Day[data-group-id="${groupId}"]`);

        allElementsWithSameGroup.forEach(element => {
          // element.classList.remove('duplicate-id-hover');
          element.classList.remove('special-case-id-hover-left');
          element.classList.remove('special-case-id-hover-right');
          element.classList.remove('hover-full-day');
          element.classList.remove('group-hover');
          element.classList.remove('group-hover-first-half');
          element.classList.remove('group-hover-second-half');
          element.classList.remove('hover-single-left');
          element.classList.remove('hover-single-right');
          element.classList.remove('special-case-same-group-hover');
        });

        // Also remove group-hover from elements with full-day leaveType
        const fullDayElements = document.querySelectorAll('.rc-Day[leavetype="full-day"]');
        fullDayElements.forEach(element => {
          element.classList.remove('group-hover');
        });

      }

      // If this is a combined entry (has secondaryId), also remove highlight from elements with secondary group ID
      if (secondaryId) {
        const allElementsWithSecondaryGroup = document.querySelectorAll(`.rc-Day[data-secondary-group-id="${secondaryId}"]`);
        allElementsWithSecondaryGroup.forEach(element => {
          element.classList.remove('special-case-id-hover-single-right');
          element.classList.remove('duplicate-id-hover');
          element.classList.remove('special-case-id-hover');
          element.classList.remove('special-case-id-hover-left');
          element.classList.remove('hover-single-left');
          element.classList.remove('hover-full-day');
          element.classList.remove('hover-single-right');
          element.classList.remove('group-hover');
          element.classList.remove('group-hover-first-half');
          element.classList.remove('group-hover-second-half');
          element.classList.remove('special-case-id-hover-right');
        });

        // Additional cleanup for special group elements
        const specialGroupElements = document.querySelectorAll(`.rc-Day[data-special-group-id="${secondaryId}"]`);
        specialGroupElements.forEach(element => {
          element.classList.remove('hover-single-right');
          element.classList.remove('hover-single-left');
          element.classList.remove('special-case-id-hover-right');
          element.classList.remove('special-case-id-hover-left');
          element.classList.remove('group-hover');
        });
        const allElementsWithSameGroup = document.querySelectorAll(`.rc-Day[data-group-id="${secondaryId}"]`);
        allElementsWithSameGroup.forEach(element => {
          element.classList.remove('special-case-id-hover-left');
          element.classList.remove('special-case-id-hover-right');
          element.classList.remove('hover-full-day');
        });

      }

      // Also remove special-case-id-hover-left from elements with the same group ID to ensure complete cleanup
      if (groupId) {
        const allElementsWithSameGroup = document.querySelectorAll(`.rc-Day[data-group-id="${groupId}"]`);
        allElementsWithSameGroup.forEach(element => {
          element.classList.remove('special-case-id-hover-left');
        });
      }

      // Clean up hover-single-right and hover-single-left from all elements to prevent persistence
      const allCalendarDays = document.querySelectorAll('.rc-Day');
      allCalendarDays.forEach(element => {
        element.classList.remove('hover-single-right');
        element.classList.remove('hover-single-left');
      });

      // Additional cleanup specifically for hover-single-left class
      const elementsWithHoverSingleLeft = document.querySelectorAll('.rc-Day.hover-single-left');
      elementsWithHoverSingleLeft.forEach(element => {
        element.classList.remove('hover-single-left');
      });

      // Reset enhanced hover feedback for combined days
      if (groupId && secondaryId) {
        const dayElement = e.currentTarget;
        // Reset to the default title for combined days
        dayElement.title = 'Click LEFT HALF to edit first leave, RIGHT HALF to edit second leave';
        dayElement.style.cursor = 'pointer';
      }

      // Reset enhanced hover feedback for single half-day leaves
      if (secondHalfGroupId) {
        const allElementsWithSameGroup2 = document.querySelectorAll(`.rc-Day[data-second-half-group-id="${secondHalfGroupId}"]`);
        allElementsWithSameGroup2.forEach(element => {
          element.classList.remove('hover-single-right');
        });
        const dayElement = e.currentTarget;
        // Reset to default state
        dayElement.style.cursor = 'default';
        dayElement.title = '';
      }
      if (firstHalfGroupId) {
        const allElementsWithSameGroup2 = document.querySelectorAll(`.rc-Day[data-first-half-group-id="${firstHalfGroupId}"]`);
        allElementsWithSameGroup2.forEach(element => {
          element.classList.remove('hover-single-left');
        });
        const dayElement = e.currentTarget;
        // Reset to default state
        dayElement.style.cursor = 'default';
        dayElement.title = '';
      }
    },
    onClick: (e) => {
      // Check if this is a non-editable leave and skip interactions
      if (clsMods && clsMods.includes('leave-not-editable')) {
        e.preventDefault();
        e.stopPropagation();
        return; // Skip all click interactions for non-editable leaves
      }

      // Get position information for all cases that need it
      const dayElement = e.currentTarget;
      const rect = dayElement.getBoundingClientRect();
      const clickX = e.clientX - rect.left;
      const dayWidth = rect.width;
      const isLeftHalf = clickX < (dayWidth / 2);
      // Follow the same logic as onMouseMove to determine which area has which elements

      // CASE 1: Combined days (both groupId and secondaryId exist) - different groups
      if (groupId && secondaryId && !isGroup) {

        let selectedId;
        if (isLeftHalf) {
          selectedId = groupId;

        } else {
          // Check if there's a special case with group for secondaryId
          const specialCaseWithGroup = document.querySelectorAll(`.rc-Day[data-special-group-id="${secondaryId}"]`);
          if (specialCaseWithGroup.length > 0) {
            selectedId = secondaryId;

          } else {
            selectedId = secondaryId;

          }
        }
        if (events && events.onClick) {
          events.onClick(date, e, selectedId, isLeftHalf);
        }
      }
      // CASE 2: Special case - same group with both halves (0,0) and (1,1) on same day
      else if (groupId && isGroup && modifiers && modifiers.firstHalfEntry && modifiers.secondHalfEntry) {
        let selectedId;
        if (isLeftHalf) {
          selectedId = groupId;
        }
        else {
          selectedId = secondaryId;
        }

        if (events && events.onClick) {
          events.onClick(date, e, selectedId, isLeftHalf);
        }
      }

      // CASE 3: Single half-day leaves
      else if (firstHalfGroupId || secondHalfGroupId) {

        let selectedId;
        if (isLeftHalf && firstHalfGroupId) {
          selectedId = firstHalfGroupId;

        } else if (!isLeftHalf && secondHalfGroupId) {
          selectedId = secondHalfGroupId;

        } else {
          selectedId = null;

        }
        if (events && events.onClick) {
          events.onClick(date, e, selectedId, isLeftHalf);
        }
      }
      // CASE 4: Single Full Day
      else if (groupId && !isGroup) {

        if (events && events.onClick) {
          events.onClick(date, e, groupId);
        }
      }
      // CASE 5: Multi-day group with complex logic
      else if (isGroup) {

        let selectedId;

        // Handle group members (dates 4, 5) - they should always show left half highlight
        if (!groupFirstHalf && !groupSecondHalf) {
          selectedId = groupId;

        }
        // Handle group with both halves
        else if (groupFirstHalf && groupSecondHalf) {
          if (isLeftHalf) {
            selectedId = groupId;

          } else {
            // Check for secondary group elements
            const secondaryGroup = document.querySelectorAll(`.rc-Day[data-secondary-group-id="${secondaryId}"]`);
            const nextGroup = document.querySelectorAll(`.rc-Day[data-group-id="${secondaryId}"]`);

            if (nextGroup.length > 0 || secondaryGroup.length > 0) {
              selectedId = secondaryId;
            } else {
              selectedId = groupId;
            }
          }
        }
        // Handle single half-day group leaves
        else if (groupFirstHalf && groupSecondHalf === null) {
          if (isLeftHalf) {
            selectedId = groupId;
          } else {
            selectedId = null;
          }
        }
        // Handle second half only group leaves
        else if (!groupFirstHalf && groupSecondHalf) {
          if (!isLeftHalf) {
            selectedId = groupId;
          } else {
            selectedId = null;
          }
        }
        // Default group case
        else {
          selectedId = groupId;
        }

        if (events && events.onClick) {
          events.onClick(date, e, selectedId, isLeftHalf);
        }
      }
      // CASE 6: Only secondaryId exists
      else if (secondaryId) {
        if (events && events.onClick) {
          events.onClick(date, e, secondaryId);
        }
      }
      // CASE 7: Only specialGroupId exists
      else if (specialGroupId) {
        if (events && events.onClick) {
          events.onClick(date, e, specialGroupId);
        }
      }
      // CASE 8: Empty day - add new leave
      else {
        if (events && events.onClick) {
          events.onClick(date, e, null);
        }
      }
    }
  };

  // Prepare data attributes
  const dataAttributes = {
    'data-date': date.format('YYYY-MM-DD')
  };

  // Add group IDs and set appropriate titles based on the type of leave
  if (groupId && secondaryId) {
    // Combined day with both halves (different groups)
    dataAttributes['data-group-id'] = groupId;
    dataAttributes['data-secondary-group-id'] = secondaryId;
    dataAttributes['data-special-group-id'] = specialGroupId;
    dataAttributes['title'] = 'Click LEFT HALF to edit first leave, RIGHT HALF to edit second leave';
  } else if (groupId && isGroup && modifiers && modifiers.firstHalfEntry && modifiers.secondHalfEntry) {
    // Special case: Same group with both halves (0,0) and (1,1) on same day
    dataAttributes['data-group-id'] = groupId;
    dataAttributes['data-special-case-same-group'] = 'true';
    dataAttributes['title'] = 'Click to edit';
  } else if (groupId) {
    // Full day leave
    dataAttributes['data-group-id'] = groupId;
    dataAttributes['leaveType'] = leaveType;
    dataAttributes['title'] = (modifiers && modifiers.title) || 'Click to edit';
  } else if (firstHalfGroupId || secondHalfGroupId) {
    // Single half-day leave
    if (firstHalfGroupId) {
      dataAttributes['data-first-half-group-id'] = firstHalfGroupId;
    }
    if (secondHalfGroupId) {
      dataAttributes['data-second-half-group-id'] = secondHalfGroupId;
    }

    if (firstHalfGroupId && secondHalfGroupId) {
      // Both halves have leaves (shouldn't happen with current logic, but just in case)
      dataAttributes['title'] = 'Click LEFT HALF to edit first leave, RIGHT HALF to edit second leave';
    } else if (firstHalfGroupId) {
      dataAttributes['title'] = (modifiers && modifiers.title) || 'Click LEFT HALF to edit leave, RIGHT HALF to add new leave';
    } else if (secondHalfGroupId) {
      dataAttributes['title'] = (modifiers && modifiers.title) || 'Click LEFT HALF to add new leave, RIGHT HALF to edit leave';
    }
  } else if (secondaryId) {
    // Special case: only secondaryId exists (combined entry without primary id)
    dataAttributes['data-secondary-group-id'] = secondaryId;
    dataAttributes['data-special-group-id'] = specialGroupId;
    dataAttributes['title'] = 'Click to edit';
  } else {
    dataAttributes['title'] = 'Click to add leave';
  }

  return (
    <div
      className={clsDay}
      style={styles}
      {...enhancedEvents}
      {...dataAttributes}
    >
      <div className="firstHalf" />
      <div className="weekNumber">
        {renderHeader(props)}
        {date.format(props.dayFormat)}
        {renderAgenda(props)}
      </div>
      <div className="secondHalf" />
    </div>
  );
};

Day.propTypes = {
  //date: React.PropTypes.object.isRequired,
  //dayAgenda: React.PropTypes.bool,
  // dayHeader: React.PropTypes.bool,
  //dayHeaderFormat: React.PropTypes.string,
  // dayFormat: React.PropTypes.string,
  // mods: PropTypes.array
};

Day.defaultProps = {
  dayAgenda: false,
  dayHeader: false,
  dayHeaderFormat: "MMM Do",
  dayFormat: "D"
};

export default Day;
